module.exports = __webpack_public_path__ + "static/media/shape2.954e4666.svg";